export default "__VITE_PUBLIC_ASSET__22a1fe93__"